import React, { Component } from 'react';
import ModalDecorator from 'hocs/ModalDecorator';
import { $ } from 'rype-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { BILLING_CYCLE, PLAN_LIMIT } from 'config/constants';
import { setBookingData } from 'actions/userActions';
import './style.css';

class UpgradeMembershipModal extends Component {
  constructor() {
    super();

    $.noConflict();

    this.state = {
      planLimit: PLAN_LIMIT.HOURS_15,
      billingCycle: BILLING_CYCLE.PREPAID,
    };
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $('#upgrade-membership-modal').modal('show'), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $('#upgrade-membership-modal').on('hidden.bs.modal', () => {
      this.props.closeModal();
    });
  }

  close = () => {
    if (this.props.modalProps && this.props.modalProps.bookingData) {
      this.props.setBookingData(this.props.modalProps.bookingData);
    }
    // Call 'hide' to reset all the Bootstrap styling
    $('#upgrade-membership-modal').modal('hide');
  };

  handleSelectPlanLimit = (value) => {
    this.setState({ planLimit: value });
  };

  handleSelectCycle = (value) => {
    this.setState({ billingCycle: value });
  };

  render() {
    const { modalProps } = this.props;
    const upgradeAction =
      modalProps.upgradeAction || '/profile/plans-and-billing';
    return (
      <div
        id="upgrade-membership-modal"
        className="UpgradeMembershipModal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="pause-membership-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src="/assets/rype-logo.png" alt="logo" className="mb-3" />
              <h4 className="mt-4">You&#39;ve hit your limits!</h4>
              <h5 className="mt-4">
                Upgrade your membership today
                <br />
                to unlock more lessons.
              </h5>
              <Link
                className="btn btn-primary mt-5"
                to={upgradeAction}
                onClick={this.close}
              >
                Yes! Unlock more lessons
              </Link>
              <div className="mt-3 text-center">
                <button
                  type="button"
                  className="btn btn-link d-block btn-cancel"
                  onClick={this.close}
                >
                  NOT NOW
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    modalProps: state.visibleModal.props,
  };
}

export default compose(
  ModalDecorator('upgrade-membership-modal'),
  connect(mapStateToProps, { setBookingData })
)(UpgradeMembershipModal);



// WEBPACK FOOTER //
// ./src/components/modals/UpgradeMembershipModal/index.js